import RevealLeft from './RevealLeft';
import StepVisual from './StepVisual';

export default function StepRow({ index, title, body, visualSrc }) {
  return (
    <div className="step-row">
      <p className="step-row__index">{index}</p>
      <div className="step-row__rule" />
      <div className="step-row__content">
        <RevealLeft className="step-row__title-wrap">
          <h3 className="step-row__title">{title}</h3>
        </RevealLeft>
        <p className="step-row__body">{body}</p>
        <StepVisual src={visualSrc} />
      </div>
    </div>
  );
}